import { useEffect, useState } from "react";
import Table from "../../../../components/Table";
import MaterialTypography from "../../../../components/MaterialTypography";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { fetchData } from "../../../../api/Services";
import { FileUpload, FilterAlt } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { deleteData, postData } from "../../../../services";
import { useSnackbar } from "../../../../context/popup";
import UploadFile from "../../../Utils/UploadFile";
import { setCircleLoading } from "../../../../components/Loading";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store";
import ModelFilterDialog from './component/ModelFilterDialog.js';

const InsurerModel = ({tabState}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { showSnackbar } = useSnackbar();
  const [isRefresh, setIsRefresh] = useState(false);
  const currentPage = useSelector(
    (state) => state?.insurerModelReducer?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.insurerModelReducer?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.insurerModelReducer?.totalPages
  );

  const [modelData, setModelData] = useState([]);
  const [search, setSearch] = useState("");

  //dialogstate
  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
    isActive: "",
    gInsurerId: ""
  });

  useEffect(() => {
    if(tabState === "model"){
      fetchModelData();
    }
  }, [isRefresh, currentPage, rowsPerPage, search]);

  const fetchModelData = async () => {
    setCircleLoading(true);
    try {

      let url = `/reference/insurer/model?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&gInsurerId=${filterData?.gInsurerId}`
      if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
          url += `&isActive=${filterData.isActive}`;
      }
      const response = await fetchData(url);
      const successResponse = response?.success;
      if (successResponse) {
        setModelData(response?.data?.items);
        dispatch(setTotalPages(response?.data?.totalPages));
      } else {
        showSnackbar("Failed to fetch Model data","error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showSnackbar(error?.response?.data?.message, "error");
    } finally {
      setCircleLoading(false);
    }
  };

    //bulk file upload api function
  const handleFileUploadSuccess = async (file) => {
    setFileUploading(true);
    setUploadSuccess(false);

    try {
      const formData = new FormData();

      formData.append("file", file);

      const result = await postData(
        `/reference/motor/insurer/bulkUpload/insurer-model`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (result?.success) {
        setUploadSuccess(true);
        showSnackbar(result?.message, "success");
        setOpenUploadFileDialog(false);
        setClearFileOnSuccess(true);
        fetchModelData();
      } else {
        setUploadSuccess(false);
        showSnackbar("Faiiled to upload file", "error");
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      console.error("Upload error:", error || errorMessage);
      showSnackbar(errorMessage, "error");
    } finally {
      setFileUploading(false);
    }
  };

  const handleDelete = async (row) => {
    try {
      const response = await deleteData(`/reference/insurer/model/delete`, {
        ids: [row?.id],
      });
      setIsRefresh(!isRefresh);
      const responseMessage = response?.message;
      if (response?.success) {
        showSnackbar(responseMessage,"success");
      } else {
        showSnackbar(responseMessage,"error");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      showSnackbar(error?.response?.data?.message, "error");
    }
  };

  const columns = [
    {
      key: "sno",
      label: "S.No.",
      renderCell: (row) => row.sno,
    },
    {
      key: "name",
      label: "Model Name",
      renderCell: (row) => row.name,
    },
     {
      key: "createdAt",
      label: "Created At",
      renderCell: (row) => new Date(row.createdAt).toLocaleDateString('en-IN'),
    },
    {
      key: "isActive",
      label: "Status",
      renderCell: (row) => (
        <span>
          {row.isActive ? (
            <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
          ) : (
            <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
          )}
        </span>
      ),
    },
  ];

  const rows = modelData?.map((model, index) => ({
    ...model,
    sno: index + 1,
  }));

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };

  const handleEdit = (row) => {
    navigate(
      `/insurer-master/insurer-motor-mmv/add-insurer-model?pageType=edit&id=${row.id}`
    );
  };

  const handleView = (row) => {
    navigate(
      `/insurer-master/insurer-motor-mmv/add-insurer-model?pageType=view&id=${row.id}`
    );
  };

  const actions = {
    edit: true,
    view: true,
    delete: true,
    onEdit: (row) => handleEdit(row),
    onView: (row) => handleView(row),
    onDelete: (row) => handleDelete(row),
  };

  const handleAddNewModel = () => {
    navigate("/insurer-master/insurer-motor-mmv/add-insurer-model");
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <div>
      <CardHeader
        title={
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Motor Model management list
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of motor model that you can get details of motor model.
              </MaterialTypography>
            </Stack>

            <Stack direction="row" spacing={1}>
              <MaterialButton
              variant="gradient"
              color="dark"
              size="small"
              startIcon={<FilterAlt/>}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                Filter
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FileUpload />}
                onClick={() => setOpenUploadFileDialog(true)}
              >
                Bulk Upload
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddNewModel()}
              >
                Add Model
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <Card sx={{ mx: 1 }}>
        <Table
          columns={columns}
          data={rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel={"No motor model data found"}
          handleSearch={handleSearch}
        />
      </Card>

      <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={["csv", "xlsx"]}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
      />
      <ModelFilterDialog
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      filterData={filterData}
      setFilterData={setFilterData}
      onApply={() => {
          setAnchorEl(null);   // close popup
          fetchModelData();  // call API after filter applied
      }}
      />
    </div>
  );
};

export default InsurerModel;
